module.exports = __webpack_public_path__ + "static/habeas-data-title-e8964fbc0812d5195d63db00385fe033.png";